import { render, staticRenderFns } from "./list-stand.vue?vue&type=template&id=65d1e1a0&"
import script from "./list-stand.vue?vue&type=script&lang=js&"
export * from "./list-stand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports